import { useCallback, Key, SetStateAction, useState } from 'react';
import { UsersRequest } from '../../../../store/reducers/UsersSlice';
import { useUsersHandlersFilter } from './useUsersHandlersFilter/useUsersHandlersFilter';

interface Props {
  onCallRequest: (
    value: UsersRequest | ((prev: UsersRequest) => UsersRequest),
  ) => void;
  callRequest: UsersRequest;
  onPageSize: (value: SetStateAction<number>) => void;
  total: number;
}

export const useUsersHandlers = ({
  onCallRequest,
  callRequest,
  onPageSize,
  total,
}: Props) => {
  const {
    handleClinicsChange,
    clinicValue,
    handleOpenClinics,
    handleRoleChange,
    roleValue,
    handleOpenRoles,
    handleIsLockoutChange,
    isLockoutValue,
    handleOpenIsLockout,
  } = useUsersHandlersFilter({
    onCallRequest,
    callRequest,
  });

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onCallRequest({
        ...callRequest,
        'Filter.TextSearch': e.target.value,
      });
    },
    [onCallRequest, callRequest],
  );

  const handleChange = useCallback(
    (page: number, pageItemCount: number) => {
      onPageSize(pageItemCount);
      onCallRequest({
        ...callRequest,
        PageIndex: page - 1,
        PageSize: pageItemCount,
      });
    },
    [onCallRequest, callRequest, onPageSize],
  );

  const handlePageSizeChange = useCallback(
    (value: string) => {
      const page =
        callRequest.PageIndex <= Math.floor(total / Number(value))
          ? callRequest.PageIndex
          : Math.floor(total / Number(value));
      onPageSize(Number(value));
      onCallRequest({
        ...callRequest,
        PageIndex: page,
        PageSize: Number(value),
      });
    },
    [callRequest, total, onPageSize, onCallRequest],
  );

  return {
    handleSearch,
    handleChange,
    handlePageSizeChange,
    handleClinicsChange,
    clinicValue,
    handleOpenClinics,
    handleRoleChange,
    roleValue,
    handleOpenRoles,
    handleIsLockoutChange,
    isLockoutValue,
    handleOpenIsLockout,
  };
};
